/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 08.09.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import $ from "jquery";
import "eonasdan-bootstrap-datetimepicker";
import "eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css";
//import "tempusdominus-bootstrap-3";
//import "tempusdominus-bootstrap-3/build/css/tempusdominus-bootstrap-3.css";

class DateTimePicker extends React.Component {
    static propTypes = {
        mode: PropTypes.oneOf(["date", "time", "date-time"]),
        inputProps: PropTypes.object,
        value: PropTypes.string,
        placeholder: PropTypes.string,
        locale: PropTypes.string,
        onChange: PropTypes.func,
        onBlur: PropTypes.func
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            id: _.uniqueId("datetimepicker")
        };
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    componentDidMount() {
        $(this.datetimepicker).datetimepicker(this.getPickerOptions(this.props));
        this.setPickerValue(this.props.value);

        //$(this.datetimepicker).on("change.datetimepicker", this.onChange);
        $(this.datetimepicker).on("dp.change", this.onChange);
    }

    componentWillUnmount() {
        // $(this.datetimepicker).datetimepicker("destroy");
        $(this.datetimepicker).data("DateTimePicker").destroy();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mode !== this.props.mode || prevProps.locale !== this.props.locale) $(this.datetimepicker).data("DateTimePicker").options(this.getPickerOptions(this.props));
        if (prevProps.value !== this.props.value) this.setPickerValue(this.props.value);
    }


    getPickerOptions(props) {
        let options = {};
        switch (props.mode) {
            case "time":
                options.format = "LTS";
                break;
            case "date-time":
                options.format = "L LTS";
                break;
            case "date":
            default:
                options.format = "L";
                break;
        }
        if (props.locale) options.locale = props.locale;
        options.date = this.getDateValue(props.value);
        return options;
    }

    setPickerValue(value) {
        //$(this.datetimepicker).datetimepicker("date", this.getDateValue(value));
        $(this.datetimepicker).data("DateTimePicker").date(this.getDateValue(value));
    }

    getDateValue(value) {
        if (value == null) return null;
        switch (this.props.mode) {
            case "time":
                let currentDate = new Date();
                let dateString = currentDate.toISOString();
                let idx = dateString.indexOf("T");
                dateString = dateString.substring(0, idx+1);
                if (value.indexOf("+") == -1 && value.indexOf("Z") == -1) value += "Z";
                return new Date(dateString + value);
            case "date-time":
            case "date":
            default:
                if (value.indexOf("+") == -1 && value.indexOf("Z") == -1) value += "Z";
                return new Date(value);
        }
    }

    getDateString(value) {
        if (!value || !value.toISOString) return null;
        let dateString = value.toISOString();
        if (!dateString) return null;
        switch (this.props.mode) {
            case "time":
                let idx = dateString.indexOf("T");
                dateString = this.fixTimeString(dateString.substring(idx+1));
                break;
            case "date-time":
                dateString = this.fixTimeString(dateString);
                break;
            case "date":
            default:
                idx = dateString.indexOf("T");
                dateString = dateString.substring(0, idx);
                break;
        }
        return dateString;
    }

    fixTimeString(timeStr) {
        if (!timeStr) return timeStr;
        let zIdx = timeStr.indexOf("Z");
        if (zIdx >= 0) {
            if (timeStr.length == zIdx + 1) timeStr = timeStr.substring(0, zIdx);
            else timeStr = timeStr.substring(0, zIdx) + "+" + timeStr.substring(zIdx+1);
        }
        else zIdx = timeStr.length;

        let dotIdx = timeStr.indexOf(".");
        if (dotIdx >= 0) {
            timeStr = timeStr.substring(0, dotIdx) + timeStr.substring(zIdx);
        }
        return timeStr;
    }

    fixTimeValue(timeValue) {
        let fixedString = this.fixTimeString(timeValue);
        if (!fixedString) return fixedString;
        return fixedString.replace("+", "Z");
    }

    onChange(e) {
        if (this.props.onChange) {
            let newValue = this.getDateString(e.date);
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }
    }

    onBlur(e) {
        e.preventDefault();
        let newValue = this.getDateString($(this.datetimepicker).data("DateTimePicker").date());
        if (this.props.onChange && newValue !== this.props.value) this.props.onChange(newValue);
        if (this.props.onBlur) this.props.onBlur(newValue);
    }

    render() {
        return (
            <div className='input-group date' id={this.state.id} ref={(r) => {this.datetimepicker = r;}} data-target-input="nearest">
                <input type='text' className="form-control datetimepicker-input" onBlur={this.onBlur} data-target={"#"+this.state.id} placeholder={this.props.placeholder} {...this.props.inputProps}/>
                <span className="input-group-addon" data-target={"#"+this.state.id} data-toggle="datetimepicker">
                    <span className="fa fa-calendar"></span>
                </span>
            </div>
        );
    }
}

export default DateTimePicker;
